import React from 'react';
import moment from 'moment';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Material Name', value: data.rawMaterialName, fullWidth: true, hideLabel: true, bold: true, fontSize: 14 },
        { label: 'Quantity', value: data.quantity },
        { label: 'Cost Per Unit', value: data.costperunit },
        { label: 'Cost', value: data.cost },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={moment(data.date).format("DD-MM-YYYY")}
            id={data.id}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
